import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { Acquisition, AcquisitionRun } from "models/acquisition-import";
import { useAuth } from "src/contexts/AuthContext";

export const useAcquisition = (acquisitionId: string) => {
  const [acquisition, setAcquisition] = useState<Acquisition | null>(null);
  const [runs, setRuns] = useState<AcquisitionRun[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchAcquisition = async (id: string, silent = false) => {
    if (!silent) setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/acquisition-imports/${id}`,
        { method: "GET" }
      );
      const data = await checkResponse(response);
      setAcquisition(data.acquisition);
      setRuns(data.runs || []);
    } catch (err) {
      console.error("Error fetching acquisition:", err);
      setError("Failed to fetch acquisition.");
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    if (acquisitionId) {
      fetchAcquisition(acquisitionId);
    }
  }, [acquisitionId]);

  return {
    acquisition,
    runs,
    loading,
    error,
    refetch: (silent?: boolean) => fetchAcquisition(acquisitionId, silent),
  };
};
